import Navigator from '../app/navigator'

class LegacyNavigatorWrapper {
    private navigator

    constructor(navigator: Navigator) {
        this.navigator = navigator
    }

    public goTo = (newParams: object): void => {
        this.navigator.replace(newParams)
    }

    public linkTo = (newParams: object): { route?: string; params: object } => {
        return {
            route: this.navigator.currentRoute(),
            params: this.getQuery(newParams),
        }
    }

    public getQuery = (newParams: object): object => {
        return this.navigator.mergeParameters(newParams)
    }
}

export default LegacyNavigatorWrapper
